/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { LoanAgreementPO } from '@/api/contract/types';
import { session } from '@/shared/utils/storage';
import { Vue, Component } from 'vue-property-decorator';

const style = require('./index.module.scss');

@Component({ name: 'YHApplyConstract' })
export default class YHApplyConstract extends Vue {
  private loanContractForm: LoanAgreementPO = Object.create(null);

  private get funderCode() {
    return [
      'MANGGUOXIAODAI',
    ].indexOf(this.loanContractForm && this.loanContractForm.funderCode) >= 0;
  }

  private created() {
    this.loanContractForm = session.get('loanContractForm') as LoanAgreementPO;
  }

  private render() {
    const {
      userName,
      effectiveDate,
    } = this.loanContractForm;
    return (
      <div class={style.ApplyConstract}>
      <div class={style.content}>
        <p class={style.title}><strong>贷款告知书</strong></p>
        <p><strong>尊敬的{userName}（先生/女士）：</strong></p>
        <p class={style.paragraph}>感谢您选择湖南快乐通宝科技小额贷款有限公司（以下简称：“快乐通宝”）贷款业务，以下重要事项请您知晓：</p>
        <p class={style.paragraph}><strong>请您仔细阅读我司的相关服务规则。如您不同意我司个人消费贷款申请规则，请不要点击确认提交个人消费贷款申请，如您点击确认提交个人消费贷款申请，即表示您已知悉并同意遵守如下内容。如您成功办理个人消费贷款业务，请您严格按照约定还款，如您逾期未还，将承担相应的法律责任。</strong></p>
        <p class={style.paragraph}>1、您承诺并保证，您在快乐通宝平台所提供的信息真实、完整、准确，并无任何虚假、误导性陈述或重大遗漏，具备我司申请资格；</p>
        <p class={style.paragraph}>2、您已同意，快乐通宝平台《注册协议》、《个人信用征信授权书》及其相关协议条款，并愿意承担相关的责任；</p>
        <p class={style.paragraph}>3、您已了解，快乐通宝有权要求您配合相关借款审查；</p>
        <p class={style.paragraph}>4、您已了解，快乐通宝有权视具体情况要求您提供进一步资料；</p>
        <p class={style.paragraph}>5、您了解并同意：无论是否同意发放贷款，您贷款申请所有提交资料均不可退回。如您违反上述第1项下承诺并因此导致快乐通宝损失，无论最终是否取得借款，您都有责任赔偿快乐通宝因此所致损失；</p>
        <p class={style.paragraph}>6、您了解并同意：任何时候或阶段不论出于何种目的，如您向快乐通宝提供了虚假信息（系统平台提交资料或有记录的口头陈述，是否虚假以我司核查结果为准），您无条件同意和接受：快乐通宝不再经您任何形式的同意，可将此类不良行为报送征信机构，并且有权采取进一步措施，追究申请人及其他提供虚假信息或资料的责任人民事及刑事责任的权利。</p>
        <p class={style.paragraph}>7、您办理的贷款业务，仅用于个人消费，请您妥善保管消费凭证，我司有权对贷款的使用、贷款资金去向进行监督，您应予以配合。</p>
        <p class={style.paragraph}>8、您办理个人消费贷款业务后，应根据相关贷款合同的约定，按时、足额偿还每期金额及相关费用。为保护您的信用记录，建议您每月在还款日前3天将当月需支付的应还款项足额存入绑定的银行卡(同时可绑定多张银行卡)，避免发生逾期。</p>
        <p class={style.paragraph}>9、您办理个人消费贷款业务后，快乐通宝后续将通过您预留的手机号与您联系，请保持手机联系畅通，号码如有变更、失效、过期等无法联系情况时，<strong>请在三个工作日内</strong>联系快乐通宝进行信息变更，否则将构成违约。</p>
        <p class={style.paragraph}>10、如您未按合同约定用途使用资金，我司有权<strong>提前收回全部贷款本息</strong>，并追究您因此对本公司造成的损失责任。</p>
        <p class={style.paragraph}>11、如您逾期，您须承担逾期滞纳金。自您逾期之日起，快乐通宝即会向您收取<strong>贷款合同约定</strong>滞纳金和逾期的本金、利息和账户管理费等。</p>
        <p class={style.paragraph}>12、您的借款行为，我们将根据《征信业管理条例》上报国家法定征信机构，如果严重逾期时我公司将采取法律手段，将<strong>您纳入失信被执行人系统</strong>，会对您进行限制高消费、限制飞机、高铁的乘坐等。</p>
        <p class={style.paragraph}>13、您严重逾期时，快乐通宝通将通过您提供给我们的相关联系方式：包括但不限于手机、短信、微信、电子邮件、信函等方式告知您后（因您未及时更新联系方式或联系方式不正确而致使未能联系到您的，视为我司已告知），如仍然未进行处理的，将采取进一步手段向您催收债务，就此您还需承担额外的费用<strong>包括但不限于诉讼费、保全费、执行费、律师费、差旅费、催收服务费等实现债权的相关费用。</strong></p>
        <div style="text-align: right">湖南快乐通宝科技小额贷款有限公司</div>
        <div style="text-align: right"><strong>{effectiveDate}</strong></div>
      </div>
      </div>
    );
  }
}
